import { useContext } from 'react';
import MUIDataTable from "mui-datatables";
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { ThemeContext } from "../Theme";
import '../css/style.css';

const DataTable = ({ columns, title, data, options, hide }) => {
    const { theme } = useContext(ThemeContext);
    const bgDard = '#1e2933';
    const bgLight = '#ffffff';
    const headerBgDard = '#19222B';
    const headerBgLight = '#F9FAFB';
    const colorDark = '#ffffff';
    const colorLight = '#3d4656';
    const lineDark = '1px solid #3d4656';
    const lineLight = '1px solid #f1f3f4';

    const getMuiTheme = () =>
        createTheme({
            shadows: Array(25).fill('none'),
            components: {
                MUIDataTable: {
                    styleOverrides: {
                        root: {
                            backgroundColor: (theme == 'dark') ? bgDard : bgLight,
                            color: (theme == 'dark') ? colorDark : colorLight,
                        },
                        IconButton: {
                            backgroundColor: (theme == 'dark') ? bgDard : bgLight,
                            color: (theme == 'dark') ? colorDark : colorLight,
                        },
                    },
                    responsiveScroll: {
                        minHeight: '800px',
                    },
                },
                MUIDataTablePagination: {
                    styleOverrides: {
                        root: {
                            color: (theme == 'dark') ? colorDark : colorLight,
                        },
                        navContainer: {
                            color: (theme == 'dark') ? colorDark : colorLight,
                        }
                    }
                },
                MUIDataTableHeadCell: {
                    styleOverrides: {
                        root: {
                            backgroundColor: (theme == 'dark') ? headerBgDard : headerBgLight,
                            //fontWeight: '200'
                        },
                    }
                },
                MuiTableCell: {
                    styleOverrides: {
                        root: {
                            padding: '5px',
                            color: (theme == 'dark') ? colorDark : colorLight,
                            fontSize: '14px',
                            fontFamily: ['Inter', 'Noto Sans Lao'],
                            borderBottom: (theme == 'dark') ? lineDark : lineLight,
                        },
                        footer: {
                            borderBottom: 'none',
                        }
                    }
                },
                MuiToolbar: {
                    styleOverrides: {
                        regular: {
                            minHeight: '8px',
                        }
                    }
                },
            }
        });

    return (
        <ThemeProvider theme={getMuiTheme()}>
            <MUIDataTable
                title={title}
                data={data}
                columns={columns}
                options={options}
            />
        </ThemeProvider>
    );
}

export default DataTable;